export default __webpack_public_path__ + "src/apps/Gastro/pages/Landing/assets/gerold@2x.jpg";